'use client'
import Header from '../component/header';
import Banner from '../component/banner';
import Footer from '../component/footer'
import SurveyQuestions from '../component/surveyquestions';
import SurveyContextProvider, { SurveyContext} from '../context/surveycontext';
import { Suspense, useContext } from 'react';

function SurveyPage(){
    return (
        <Suspense>
            <SurveyContextProvider>
                <InternalSurveyPage></InternalSurveyPage>
            </SurveyContextProvider>
        </Suspense>
    );
};

const InternalSurveyPage = () =>{

    const {
        displayMessage,        
        bannerText,
        isError
    } = useContext(SurveyContext);

    return (
        <>
        <Header singleSurvey={false}/>
        <Banner displayMessage={displayMessage} bannerText={bannerText} isError={isError} singleSurvey={false} wlSurvey={false} />
        <SurveyQuestions wlSurvey={false}/>
        <Footer singleSurvey={false}/>
        </>
    )
}

export default SurveyPage;